import React, { useState } from "react";
import { API_URL } from "../config";
import "./ChatWithKG.css";

export default function ChatWithKG() {
  const [message, setMessage] = useState("");
  const [chatLog, setChatLog] = useState([]);
  const [loading, setLoading] = useState(false);

  const sendMessage = async () => {
    if (!message.trim()) return;
    setLoading(true);

    try {
      const res = await fetch(`${API_URL}/api/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message,
          thread_id: "instructor_chat",
        }),
      });
      const data = await res.json();

      setChatLog((prev) => [
        ...prev,
        { sender: "user", text: message },
        { sender: "ai", text: data.reply || "No response." },
      ]);
      setMessage("");
    } catch (err) {
      console.error("Chat error:", err);
    }
    setLoading(false);
  };

  return (
    <div className="chatkg-container">
      <h2>💬 Chat with Knowledge Graph</h2>

      <div className="chatkg-window">
        {chatLog.map((msg, i) => (
          <div key={i} className={`chatkg-msg ${msg.sender}`}>
            <strong>{msg.sender === "user" ? "You" : "AI"}:</strong> {msg.text}
          </div>
        ))}
      </div>

      <div className="chatkg-input">
        <input
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Ask about your Knowledge Graph..."
        />
        <button onClick={sendMessage} disabled={loading}>
          {loading ? "..." : "Send"}
        </button>
      </div>
    </div>
  );
}
